import { ColorPaletesType, borders, colors } from "../../tokens";
import { getColorWithOpacity } from "../../utils/color.util";

export const getCircleBackgroundColor = (color: ColorPaletesType): string => colors[color];

export const getCircleBorderColor = (color: ColorPaletesType): string => getColorWithOpacity(colors[color], 0.6);

export const getBorderWidth = (): string => borders.width.hairlene;
